import React from "react";
import { Row, Col } from "antd";
import "./TransferDetailsPanel.scss";
import FieldValueVerticalCell from "components/general/FieldValueVerticalCell";
import { formatMoney, formatExchangeRate } from "utils/utils";
import {displayNumberWithComma} from "../../utils/utils";
import FieldValueSignUpVerticalCell from "../general/FieldValueSingUpVerticalCell";
import Icon from "antd/es/icon";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";

class CustomerTierTransferDetailsPanel extends React.Component {
  formatFee = fee => {
    return formatMoney(fee) + " " + this.props.sourceValue.currency;
  };

  formatArrivalEstimation = estimation => {
    return "in " + estimation + " day";
  };

  generateExchangeRate = () => {
    const { sourceValue, targetValue } = this.props;
    if(targetValue.currency === 'VND'
        || targetValue.currency === 'IDR'){
      return (
        <span>
          1 {sourceValue.currency} &rarr; {displayNumberWithComma(this.props.exchangeRate.toFixed(0))} {targetValue.currency}
        </span>
      )
    }else{
      return (
        <span>
          1 {sourceValue.currency} &rarr; {formatExchangeRate(this.props.exchangeRate)} {targetValue.currency}
        </span>
      )
    }
    
  };

  generateInverseRate = () => {
    const { sourceValue, targetValue, factors } = this.props;
    if(factors){
      if(factors[sourceValue.currency][targetValue.currency] === 1){
        return (
            <span>
          1 {targetValue.currency} &rarr; {formatExchangeRate(1 / this.props.exchangeRate)} {sourceValue.currency}
        </span>
        )
      }else{
        let factor = factors[sourceValue.currency][targetValue.currency];
        return (
            <span>
          {factor} {targetValue.currency} &rarr; {formatExchangeRate((1 / this.props.exchangeRate) * factor) } {sourceValue.currency}
        </span>
        )
      }
    }
  };

  render() {
    const intl = this.props.useIntl;
    return (
      <div className="transfer-details-panel-signup">
        <Row>
          <Col md={7} sm={12}>

          </Col>
          
          <Col md={7} sm={12}>



            {/*<FieldValueSignUpVerticalCell*/}
            {/*  title="Exchange Rate"*/}
            {/*  value={this.generateExchangeRate()}*/}
            {/*/>*/}

            <FieldValueSignUpVerticalCell
                title={intl.formatMessage({id: "app.panel.transferdetailspanel.amountconverted"})}
                value={displayNumberWithComma(this.props.convertedAmount)}
                currency={this.props.sourceValue.currency}
            />
            <FieldValueSignUpVerticalCell
                style={{ marginTop: 16}}
                className="inverse-exchang-rate"
                title={intl.formatMessage({id: "app.panel.transferdetailspanel.remittancefees"})}
                value={this.formatFee(this.props.fee)}
            />
          </Col>
          <Col md={7} sm={12}>

            <FieldValueSignUpVerticalCell
                title={intl.formatMessage({id: "app.panel.transferdetailspanel.exchangerate"})}
                value={this.generateExchangeRate()}
            />
            <FieldValueSignUpVerticalCell
                style={{ marginTop: 16}}
              className="inverse-exchang-rate"
              title={intl.formatMessage({id: "app.panel.transferdetailspanel.inverseexchangerate"})}
              value={this.generateInverseRate()}
            />


          </Col>
          <Col md={7} sm={12}>
          </Col>


        </Row>
        <br/>
        <Row>
          <Col>
            <div style={{textAlign:'center'}}>
                <FormattedMessage id="app.panel.transferdetailspanel.updated"/>{' '}<span><Icon style={{marginLeft: '10px'}} type="dashboard"></Icon></span><span
                style={{marginLeft: '7px'}}>
                {this.props.timeUpdateRate}</span>
              <span style={{marginLeft: '15px'}}> {this.props.dateUpdateRate}</span>
            </div>
          </Col>
        </Row>
        {this.props.showRateInFoReference && (
        <Row><Col><div style={{textAlign:'center',fontStyle:'italic', marginTop:'5px'}}><FormattedMessage id="app.message.transferdetailspanel.spotratefromrefinitiv"/></div></Col></Row>)}
      </div>
    );
  }
}

export default withUseIntl(CustomerTierTransferDetailsPanel);